import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Footer from "../../layout/Footer/Footer";

export default function ForgetPassword() {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const [isLoading, setLoading] = useState(false);
    const [isDisabled, setDisabled] = useState(false);

    const validateEmail = (email) => {
        const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return regex.test(email);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setMessage("");

        if (!validateEmail(email)) {
            setError("Invalid email address");
            return;
        };
        setLoading(true);

        try {
            const response = await axios.post(
                `${import.meta.env.VITE_API_URL}/auth/forget-password`,
                { email }
            );
            setMessage(response.data.message);
            setDisabled(true);
        } catch (err) {
            setError(err.response?.data?.message || "An error occurred");
        } finally {
            setLoading(false);
        }
    };
    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100">
          <form
            onSubmit={handleSubmit}
            className="card bg-base-100 w-full max-w-sm shadow-xl p-6"
          >
            <h2 className="text-xl font-bold mb-4">Forgot Password</h2>
            {message && <p className="text-green-500 text-sm mb-4">{message}</p>}
            {error && <p className="text-red-500 text-sm mb-4">{error}</p>}
            <label
              htmlFor="email"
              className="block text-sm font-medium leading-6 text-gray-900"
            >
              Email Address
            </label>
            <input
              id="email"
              type="email"
              placeholder="Enter your email"
              className="input input-bordered w-full mb-4"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={isLoading || isDisabled} // Disable input เมื่อ Loading หรือปุ่มถูก Disable
            />
            <button
              type="submit"
              className={`btn btn-neutral bg-black hover:bg-gray-800 w-full flex justify-center items-center ${
                isLoading || isDisabled ? "cursor-not-allowed" : ""
              }`}
              disabled={isLoading || isDisabled} // Disable ปุ่มเมื่อ Loading หรือส่งสำเร็จ
            >
              {isLoading ? (
                <span className="loading loading-dots loading-lg"></span>
              ) : (
                "Send Reset Link"
              )}
            </button>
            {/* ปุ่ม Back to Login */}
            <div className="flex justify-center mt-4">
              <button
                type="button"
                onClick={() => navigate("/login")} // redirect ไปยังหน้า login
                className="text-gray-500 hover:text-blue-700 flex items-center justify-center gap-2"
              >
                <i className="fa-solid fa-arrow-left"></i>{" "}
                {/* เพิ่มไอคอน FontAwesome */}
                Back to Login
              </button>
            </div>
          </form>
          <Footer />
        </div>
      );
};